<script lang="ts" setup>
const props = defineProps({
  name: {
    type: String,
    default: '',
  },

  photo: {
    type: String,
    default: '',
  },

  position: {
    type: String,
    default: '',
  },

  resume: {
    type: String,
    default: '',
  },

  intro: {
    type: String,
    default: '',
  },

  targ: {
    type: String,
    default: '',
  },
});
</script>

<template>
  <div class="people-card">
    <div class="relative h-160px">
      <img class="lazyload block h-full w-160px rounded-4px object-cover" :data-src="props.photo" :alt="props.name">
      <div class="people-card__info absolute left-135px top-50% box-border h-64px max-w-120px rounded-3px bg-[length:38px_38px] bg-white bg-left-top bg-no-repeat px-5px <2xl:max-w-100px -translate-y-50%">
        <p class="m-0 mt-8px truncate text-center text-14px text-brand-primary font-medium" :title="props.position">{{ props.position }}</p>
        <p class="m-0 mt-10px truncate text-center text-16px text-brand-normal font-normal" :title="props.name">{{ props.name }}</p>
      </div>
      <span class="targ absolute top-0 block h-20px w-70px truncate text-center text-12px color-hex-fff leading-20px tracking--0.5px" v-if="targ">{{ props.targ }}</span>
    </div>
    <p class="mx-0 mb-0 mt-10px max-h-120px overflow-x-auto text-14px text-brand-gray font-normal leading-20px" :title="props.resume" v-if="props.intro">
      {{ props.intro }}
    </p>
  </div>
</template>

<style lang="scss" scoped>
.people-card {
  .people-card__info {
    min-width: 88px;
    background-image: url(@@home/assets/about/bg-1.svg);
    box-shadow: 0 0 16px 0 rgba(0, 0, 0, 0.04);
  }

  .targ {
    background-image: linear-gradient(-66deg, #5be6ff 0%, #1180ff 100%);
    border-radius: 0 0 4px 0;
    box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.1);
  }
}
</style>
